import React from 'react';
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import Layout from "@/Shared/Layout";
import SearchFilter from "@/Shared/SearchFilter";
import Icon from "@/Shared/Icon";
import Pagination from "@/Shared/Pagination";
import TableHeadSort from "@/Shared/TableHeadSort";
import dayjs from "dayjs";
import PermissionsGate from "@/Shared/PermissionsGate";
import PaginateCount from "@/Shared/PaginateCount";

const Index = () => {
  const {adminUsers} = usePage().props;
  const {
    data,
    meta: {links}
  } = adminUsers;

  return (
    <div>
      <div className={'mb-3 flex justify-between items-center'}>
        <h1 className=" text-3xl font-bold">Admin-users</h1>

        <PermissionsGate scopes={['create-user']}>
          <InertiaLink
            className="btn-default focus:outline-none"
            href={route('admin-users.create')}
          >
            <span>Create</span>
            <span className="hidden md:inline"> User</span>
          </InertiaLink>
        </PermissionsGate>
      </div>

      <div className="flex items-center justify-between mb-6">
        <SearchFilter/>

        <PaginateCount/>
      </div>
      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="w-full whitespace-nowrap">
          <thead>
          <tr className="font-bold text-left">
            <TableHeadSort sortName='name' title='Name'/>
            <TableHeadSort sortName='email' title='Email'/>
            <TableHeadSort sortName='role' title='Role'/>
            <TableHeadSort sortName='created_at' title='Creation date'/>
          </tr>
          </thead>
          <tbody>
          {data.map(({id, name, photo, email, role, deleted_at, created_at}) => {
            return (
              <tr
                key={id}
                className="hover:bg-gray-100 focus-within:bg-gray-100"
              >
                <td className="border-t">
                  <InertiaLink
                    href={route('admin-users.edit', id)}
                    className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                  >
                    {photo && (
                      <img
                        src={photo}
                        className="block w-5 h-5 mr-2 -my-2 rounded-full"
                      />
                    )}
                    {name}
                    {deleted_at && (
                      <Icon
                        name="trash"
                        className="flex-shrink-0 w-3 h-3 ml-2 text-gray-400 fill-current"
                      />
                    )}
                  </InertiaLink>
                </td>
                <td className="border-t">
                  <InertiaLink
                    tabIndex="-1"
                    href={route('admin-users.edit', id)}
                    className="flex items-center px-6 py-4 focus:text-indigo focus:outline-none"
                  >
                    {email}
                  </InertiaLink>
                </td>
                <td className="border-t">
                  <InertiaLink
                    tabIndex="-1"
                    href={route('admin-users.edit', id)}
                    className="flex items-center px-6 py-4 focus:text-indigo focus:outline-none"
                  >
                    {role.role}
                  </InertiaLink>
                </td>
                <td className="border-t">
                  <InertiaLink
                    tabIndex="-1"
                    href={route('admin-users.edit', id)}
                    className="flex items-center px-6 py-4 focus:text-indigo focus:outline-none"
                  >
                    {!!created_at && dayjs(created_at).format('DD.MM.YYYY')}
                  </InertiaLink>
                </td>
                <td className="w-px border-t">
                  <InertiaLink
                    tabIndex="-1"
                    href={route('admin-users.edit', id)}
                    className="flex items-center px-4 focus:outline-none"
                  >
                    <Icon
                      name="cheveron-right"
                      className="block w-6 h-6 text-gray-400 fill-current"
                    />
                  </InertiaLink>
                </td>
              </tr>
            );
          })}
          {data.length === 0 && (
            <tr>
              <td className="px-6 py-4 border-t" colSpan="4">
                No users found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links}/>
    </div>
  );
};

Index.layout = page => <Layout children={page} title="Admin panel users"/>
export default Index;
